
import {
  defineComponent,
  PropType,
  ref,
  watch,
  onMounted,
} from 'vue';
import { useI18n } from 'vue-i18n';
import {
  FieldConfig,
  ParserFieldObject,
  Property,
} from '@/types';

export default defineComponent({
  name: 'WheelPointerPositionField',

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true,
    },
  },

  emits: ['on-change-properties'],

  setup(props, { emit }) {
    const { t } = useI18n();
    const property = ref<Property>(props.parserValues.properties[0]);
    const selectedPosition = ref<string>('top');

    const positions = [
      { value: 'top', label: 'templateBuilder.games.wheelPointerPosition.top' },
      { value: 'bottom', label: 'templateBuilder.games.wheelPointerPosition.bottom' },
      { value: 'left', label: 'templateBuilder.games.wheelPointerPosition.left' },
      { value: 'right', label: 'templateBuilder.games.wheelPointerPosition.right' },
    ];

    const parseInitialValue = () => {
      const value = property.value.value;
      if (value && typeof value === 'string' && positions.some(p => p.value === value)) {
        selectedPosition.value = value;
      } else {
        selectedPosition.value = 'top';
      }
    };

    const emitChange = () => {
      property.value.value = selectedPosition.value;
      emit('on-change-properties', {
        selector: props.parserValues.selector,
        properties: [property.value],
      });
    };

    const selectPosition = (position: string) => {
      selectedPosition.value = position;
      emitChange();
    };

    onMounted(() => {
      parseInitialValue();
    });

    watch(() => props.parserValues.properties[0]?.value, () => {
      parseInitialValue();
    }, { deep: true });

    return {
      t,
      selectedPosition,
      positions,
      selectPosition,
    };
  },
});
